/* eslint-disable */
const HttpCode = {
  UNAUTHORIZED: 401,
  NOTFOUND: 404
};

export default HttpCode;
